import {
    AllEnvironmentName,
    EnvironmentName,
    PALPATINE_FRONT_URL_FROM_ENVIRONMENT_NAME,
} from "waapi/environments-repository/constants/environments.js";

export const getCurrentStagingEnvName = (): AllEnvironmentName => {
    const env = (Object.keys(PALPATINE_FRONT_URL_FROM_ENVIRONMENT_NAME) as Array<AllEnvironmentName>).find((key) =>
        PALPATINE_FRONT_URL_FROM_ENVIRONMENT_NAME[key].includes(window.location.host),
    );
    return env ?? EnvironmentName.PROD;
};
